import statusConst from '@/consts/status.const.js';
import pixAxios from '@/axios/pixAxios.js';

const auditLogModule = {
  namespaced: true,
  state: {
    auditLog: null,
    status: statusConst.PENDING,
  },
  actions: {
    async loadAuditLog({ state, commit, dispatch }, { id, bPartial }) {
      commit('setStatus', statusConst.LOADING);
      dispatch('loadingOverlayModule/setIsLoading', true, { root: true });
      const { data } = await pixAxios.get(`api/Audit/GetAuditLog?id=${id}&culture=${bPartial}`);
      dispatch('loadingOverlayModule/setIsLoading', false, { root: true });
      commit('setAuditLog', data);
      commit('setStatus', statusConst.SUCCESS);
    },

    closeModal({ state, commit }) {
      commit('setAuditLog', null);
    },

    setStatus({ commit }, payload) {
      commit('setStatus', payload);
    },
  },

  mutations: {
    setAuditLog(state, auditLog) {
      state.auditLog = auditLog;
    },

    setStatus(state, payload) {
      state.status = payload;
    },
  },

  getters: {
    getAuditLog(state) {
      return state.auditLog;
    },

    getStatus(state) {
      return state.status;
    },
  },
};
export default auditLogModule;
